"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._isEmail = exports._makeStringUnique = exports._removeBlankFields = exports._booleish = exports._toBool = exports._toFloat = exports._toInteger = exports._chunkify = exports._emptyStringToNull = exports._isBlank = void 0;
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const isObject_1 = __importDefault(require("lodash/isObject"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const isFinite_1 = __importDefault(require("lodash/isFinite"));
const isDate_1 = __importDefault(require("lodash/isDate"));
const isString_1 = __importDefault(require("lodash/isString"));
const _isBlank = function (value) {
    return (value === undefined ||
        value === null ||
        ((0, isString_1.default)(value) && value.trim() === '') ||
        value.toString().length === 0 ||
        ((0, isObject_1.default)(value) && (0, isEmpty_1.default)(value) && typeof value !== 'function' && !(0, isDate_1.default)(value)));
};
exports._isBlank = _isBlank;
const _emptyStringToNull = function (str) {
    if (str === '') {
        return null;
    }
    return str;
};
exports._emptyStringToNull = _emptyStringToNull;
const _toInteger = function (value, defaultValue = null) {
    const number = typeof value === 'string' ? parseInt(value) : value === null || value === undefined ? null : Math.trunc(value);
    return (0, isFinite_1.default)(number) && Number.isInteger(number)
        ? number
        : defaultValue === null
            ? null
            : Math.trunc(defaultValue);
};
exports._toInteger = _toInteger;
const _toFloat = function (value, defaultValue = null) {
    const number = typeof value === 'string' ? parseFloat(value) : value === null || value === undefined ? null : value;
    return (0, isFinite_1.default)(number) ? number : defaultValue;
};
exports._toFloat = _toFloat;
const _toBool = function (value, defaultValue = null) {
    if (value === 'true' || value === true) {
        return true;
    }
    else if (value === 'false' || value === false) {
        return false;
    }
    return defaultValue;
};
exports._toBool = _toBool;
// split array in any number of slices:
// Thanks to https://stackoverflow.com/a/8189268
const _chunkify = function (a, n = 2, balanced = true) {
    const len = a.length;
    const initialN = n;
    if (n < 2 || len === 0) {
        return [a];
    }
    const out = [];
    let i = 0;
    let size;
    if (len % n === 0) {
        size = Math.floor(len / n);
        while (i < len) {
            out.push(a.slice(i, (i += size)));
        }
    }
    else if (balanced) {
        while (i < len) {
            size = Math.ceil((len - i) / n--);
            out.push(a.slice(i, (i += size)));
        }
    }
    else {
        n--;
        size = Math.floor(len / n);
        if (len % size === 0) {
            size--;
        }
        while (i < size * n) {
            out.push(a.slice(i, (i += size)));
        }
        out.push(a.slice(size * n));
    }
    while (initialN - out.length > 0) {
        out.push([]);
    }
    return out;
};
exports._chunkify = _chunkify;
// returns true for trueish values, false for falseish values and null otherwise. Will accept upper and lowercase values as same
const _booleish = function (value) {
    const lowercaseValue = typeof value === 'string' ? value.toLowerCase() : Array.isArray(value) ? '' : String(value).toLowerCase();
    return ['y', 'yes', 'true', 't', '1', 'on'].includes(lowercaseValue)
        ? true
        : ['n', 'no', 'false', 'f', '0', 'off'].includes(lowercaseValue)
            ? false
            : null;
};
exports._booleish = _booleish;
/**
 * Remove all undefined or null fields from an object. This is useful to convert
 * a database object, with null values to application objects, where undefined
 * values should be preferred instead.
 *
 * The object is modified itself is modified
 *
 * @template T The type of the object
 * @param {T} obj The object whose fields to delete if they are null or
 * undefined
 * @return {*}  {T} The object itself
 */
const _removeBlankFields = (obj) => {
    for (const field in obj) {
        if (obj[field] === null || obj[field] === undefined) {
            delete obj[field];
        }
    }
    return obj;
};
exports._removeBlankFields = _removeBlankFields;
/**
 * Return a string that starts with str, but that is not contained in
 * otherStrings array, adding numeric suffixes to the string
 *
 * @param str The string to make unique
 * @param otherStrings A string array containing the values that should not be
 * identical to the returned string
 * @return {*}  {string} A unique string that has no duplicate in the
 * otherStrings array
 */
const _makeStringUnique = (str, otherStrings) => {
    let sameString = otherStrings.find((other) => other === str);
    if (!sameString) {
        return str;
    }
    let suffixNumber = 0;
    while (sameString) {
        suffixNumber++;
        sameString = otherStrings.find((other) => other === `${str}-${suffixNumber}`);
    }
    return `${str}-${suffixNumber}`;
};
exports._makeStringUnique = _makeStringUnique;
const _isEmail = (maybeEmail) => {
    return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(maybeEmail);
};
exports._isEmail = _isEmail;
//# sourceMappingURL=LodashExtensions.js.map